import axios from "axios";

//* Все URL
export const CONFIG = {
    // SERVER_URL: 'https://serv.idgos.ru/index.php',

    //! Боевой
    SERVER_URL: 'https://dev.idgos.ru/index.php',

    TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6OCwibG9naW4iOiJtYWthcmtpbiIsImlhdCI6MTcxNTg0MjU1OSwiZXhwIjoxNzE3MDUyMTU5fQ.1gteigYgoJs--14cAj272SDhVsDXRcv0EK1RLGJ_J6Q',
    CODE_URL: 'https://idgos.ru/index.php?route=user/signuser/get-code',
};


//* Боевой
class ServerApi {
    constructor() {
        this.serverUrl = CONFIG.SERVER_URL;
        this.token = CONFIG.TOKEN;
    }

    //Расшифровка ссылки, возвращает код пользователя и оператора.
    //Инициализация приложения.
    async Init(url) {
        const body = JSON.stringify({
            action: 'Init',
            data: {
                url: url,
            },
        });
        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

    //Возвращает данные об операторе. Название компании.
    async getOperatorInfo(code, debag, appLogicType) {
        const body = JSON.stringify({
            action: 'getOperatorInfo',
            data: {
                code: code,
                ...(debag !== undefined && ((debag || debag === 'true') && { debag: debag })),
                ...((appLogicType === '2' || appLogicType === 2) && { type: appLogicType }),
            }
        });

        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

    //Получение ссылки на подписание
    async getEsiaLink(code, debag, appLogicType) {
        const body = JSON.stringify({
            action: 'getEsiaLink',
            data: {
                code: code,
                ...((debag !== undefined && debag !== 'undefined') && ((debag || debag === 'true') && { debag: debag })),
                ...((appLogicType === '2' || appLogicType === 2) && { type: appLogicType }),
            },
        });

        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

    //Получение данных от Esia
    async setEsiaData(code, esia_token, debag, appLogicType) {
        const body = JSON.stringify({
            action: 'setEisaData',
            data: {
                code: code,
                esia_token: esia_token,
                ...((debag !== undefined && debag !== 'undefined') && ((debag || debag === 'true') && { debag: debag })),
                ...((appLogicType === '2' || appLogicType === 2) && { type: appLogicType }),
            },
        });
        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

    //* КЕЙС - 2
    //Финализирует статус, отправляет данные ЕСИА заказчику
    async completeData (code, debag) {
        const body = JSON.stringify({
            action: 'completeData',
            data: {
                code: code,
                ...((debag !== undefined && debag !== 'undefined') && ((debag || debag === 'true') && { debag: debag })),
            },
        });
        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

    //* КЕЙС - 1
    //Список документов для подписи
    async getDocumentList(code, debag) {
        const body = JSON.stringify({
            action: 'getDocumentList',
            data: {
                code: code,
                ...((debag !== undefined && debag !== 'undefined') && ((debag || debag === 'true') && { debag: debag })),
            },
        });
        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

    //Запрос на предпросмотр документа
    async getPreviewOne(code, document_id, debag) {
        const body = JSON.stringify({
            action: 'getPreviewOne',
            data: {
                code: code,
                document_id : document_id,
                ...((debag !== undefined && debag !== 'undefined') && ((debag || debag === 'true') && { debag: debag })),
            },
        });

        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

    //Отправка кода
    async setCode(code, debag, emailForSend) {
        const body = JSON.stringify({
            action: 'setCode',
            data: {
                code: code,
                ...((debag !== undefined && debag !== 'undefined') && ((debag || debag === 'true') && { debag: debag })),
                ...(emailForSend !== '' && { email: emailForSend }),
            },
        });

        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

    // Проверка кода и запуск подписания
    async getCode(code, verification, debag) {
        const body = JSON.stringify({
            action: 'getCode',
            data: {
                code: code,
                verification: verification,
                ...((debag !== undefined && debag !== 'undefined') && ((debag || debag === 'true') && { debag: debag })),
            }
        });

        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

    //Завершение процесса.
    async completeProcess(code, debag) {
        const body = JSON.stringify({
            action: 'completeProcess',
            data: {
                code: code,
                ...((debag !== undefined && debag !== 'undefined') && ((debag || debag === 'true') && { debag: debag })),
            },
        });
        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

    // Запрос на скачивание документов
    async downloadFile(code, id, fileType, debag) {
        const body = JSON.stringify({
            action: 'downloadFile',
            data: {
                code: code,
                document_id: id,
                file_type: fileType,
                ...((debag !== undefined && debag !== 'undefined') && ((debag || debag === 'true') && { debag: debag })),
            },
        });

        return await axios.post(this.serverUrl, body, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    }

    // Вспомогательные ------------------------------------------------------------------------------------------------

    //Отправить лог
    async addLog(data) {
        const body = JSON.stringify({
            action: 'addLog',
            data: data,
        });
        return await axios.post(this.serverUrl, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`,
            },
        });
    };

}

export {ServerApi};
